import { render, staticRenderFns } from "./ReporteCompartivaAreasDocente.vue?vue&type=template&id=437556e9&scoped=true"
import script from "./ReporteCompartivaAreasDocente.vue?vue&type=script&lang=js"
export * from "./ReporteCompartivaAreasDocente.vue?vue&type=script&lang=js"
import style0 from "./ReporteCompartivaAreasDocente.vue?vue&type=style&index=0&id=437556e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437556e9",
  null
  
)

export default component.exports